var map = {
	"./agent.js": 20098,
	"./sendCoupons.js": 6498,
	"./setorder.js": 42207,
	"./shop.js": 72171,
	"./system.js": 2786,
	"./user.js": 12296,
	"./vzanStore.js": 19655
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84870;